/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import type { ApolloError } from 'apollo-client';

import type {
	useCurrentUserContributorContentContributorsQuery as useCurrentUserContributorContentContributorsQuery$data,
	useCurrentUserContributorContentContributorsQueryVariables as useCurrentUserContributorContentContributorsQuery$variables,
} from './__types__/useCurrentUserContributorContentContributorsQuery';

const useCurrentUserContributorContentContributorsQuery = gql`
	query useCurrentUserContributorContentContributorsQuery($contentId: ID!) {
		contentContributors(id: $contentId) {
			isCurrentUserContributor
		}
	}
`;

type CurrentUserContributorProperties = {
	isCurrentUserContributor?: boolean;
	contentContributorsLoading: boolean;
	contentContributorsError?: ApolloError;
};

export const useCurrentUserContributor = (contentId: string): CurrentUserContributorProperties => {
	const {
		data,
		loading: contentContributorsLoading,
		error: contentContributorsError,
	} = useQuery<
		useCurrentUserContributorContentContributorsQuery$data,
		useCurrentUserContributorContentContributorsQuery$variables
	>(useCurrentUserContributorContentContributorsQuery, {
		variables: { contentId },
	});
	const isCurrentUserContributor: boolean | undefined =
		data?.contentContributors?.isCurrentUserContributor ?? undefined;

	return {
		isCurrentUserContributor,
		contentContributorsLoading,
		contentContributorsError,
	};
};
